import SearchResultJournal from './SearchResultJournal';

export default SearchResultJournal;
